import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/others/Badges";
import { ChevronLeft, BookOpen } from "lucide-react";

interface CourseHeaderProps {
  courseName: string;
  university: string;
  courseType: string;
  level: string;
  courseTypeBgColor: string;
  onBackClick: () => void;
}

export default function CourseHeader({
  courseName,
  university,
  courseType,
  level,
  courseTypeBgColor,
  onBackClick,
}: CourseHeaderProps) {
  return (
    <div className="border-b border-[var(--color-black-1)] flex  items-start">
      <Button
        variant="ghost"
        size="icon-lg"
        onClick={onBackClick}
        className="flex items-center justify-center rounded-[12px] size-7 cursor-pointer hover:bg-gray-50 transition-colors shrink-0"
      >
        <ChevronLeft size={25} className="text-[var(--color-black-9)]" />
      </Button>

      <div className="flex-1 flex gap-1 items-start">
        <div className="flex-1 flex flex-col gap-1">
          <p className="font-medium text-[var(--colorblack-10)] text-[20px] tracking-[-0.8px] leading-normal">
            {courseName}
          </p>
          <p className="font-normal text-[var(--color-black-7)] text-[12px] tracking-[-0.24px] leading-normal">
            {university}
          </p>
        </div>

        <div className="flex gap-3 items-center py-1">
          <Badge
            className="text-white py-[2px] px-2 text-[12px] tracking-[-0.24px] font-normal rounded-full flex items-center gap-1"
            style={{
              backgroundColor: courseTypeBgColor,
              boxShadow: "inset 0px 4px 4px 0px rgba(218, 249, 237, 0.25)",
            }}
          >
            <BookOpen size={14} />
            {courseType}
          </Badge>

          <Badge className="bg-[#f2f5f8] text-[#222530] py-1 px-2 text-[12px] tracking-[-0.24px] font-normal rounded-full">
            {level}
          </Badge>
        </div>
      </div>
    </div>
  );
}
